import { createSlice } from '@reduxjs/toolkit';
import { fetchAttendanceByBatchId } from 'thunks/attendenceSliceThunks/thunks';

// Helper function to get carried forward reason from previous days
const getCarriedForwardReason = (attendanceArray, currentIndex, employeeId) => {
  // Look for the most recent reason from previous days (before current index)
  for (let i = currentIndex - 1; i >= 0; i--) {
    const attendance = attendanceArray[i];
    if (attendance.absentReasons && attendance.absentReasons[String(employeeId)]) {
      return attendance.absentReasons[String(employeeId)];
    }
  }
  return ''; // Return empty string if no previous reason found
};

const initialState = {
  data: [],
  batchId: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
  selectAllClicked: false,
  errorMessage: null,
  attendence: [],
};

const attendenceSlice = createSlice({
  name: 'attendenceSlice',
  initialState,
  reducers: {
    setData(state, action) {
      action.payload.map((elem) => {
        if (!elem['attendenceMarked']) {
          elem['attendenceMarked'] = false;
        }
      });
      state.data = action.payload;
      state.isSuccess = true;
      state.isLoading = false;
    },
    setbatchId(state, actions) {
      console.log('state', state.batchId);
      state.batchId = actions.payload;
    },
    restForm(state) {
      state.data = null;
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
    },
    setError(state, action) {
      state.isError = true;
      state.errorMessage = action.payload;
      state.isLoading = false;
    },
    setSuccess(state, action) {
      state.isError = false;
      state.isSuccess = true;
      state.errorMessage = null;
    },
    markAttendence(state, action) {
      const index = state.data.findIndex((item) => item.id === action.payload.id);
      state.data[index]['attendenceMarked'] = !state.data[index]['attendenceMarked'];
    },
    addAttendence(state, action) {
      // console.log("attendence",action,JSON.parse(JSON.stringify(state)));
      const { date, emp, present, reason } = action.payload;
      // Find the index of the object in the attendance array that matches the date
      const index = state.data.data.attendance.findIndex((obj) => obj.date === date);
      console.log('index', index, present, date, reason);

      if (index !== -1 && present === true) {
        let presentEmp = emp;

        // Add `presentEmp` to the `present` array if not already present
        if (!state.data.data.attendance[index].present.includes(presentEmp)) {
          state.data.data.attendance[index].present.push(presentEmp);
        }

        // Remove `presentEmp` from the `absent` array if it exists
        const absentIndex = state.data.data.attendance[index].absent.indexOf(presentEmp);
        if (absentIndex !== -1) {
          state.data.data.attendance[index].absent.splice(absentIndex, 1);
        }

        // Clear the reason when marking as present
        if (
          state.data.data.attendance[index].absentReasons &&
          state.data.data.attendance[index].absentReasons[String(presentEmp)]
        ) {
          delete state.data.data.attendance[index].absentReasons[String(presentEmp)];
        }

        // If marking as present, clear absent status from all future days
        for (let i = index + 1; i < state.data.data.attendance.length; i++) {
          const futureAttendance = state.data.data.attendance[i];
          const futureAbsentIndex = futureAttendance.absent.indexOf(presentEmp);
          if (futureAbsentIndex !== -1) {
            futureAttendance.absent.splice(futureAbsentIndex, 1);
          }
          if (
            futureAttendance.absentReasons &&
            futureAttendance.absentReasons[String(presentEmp)]
          ) {
            delete futureAttendance.absentReasons[String(presentEmp)];
          }
        }
      }

      if (index !== -1 && present === false) {
        // logic to add in absent and remove from present.
        console.log('In absent state', reason);
        let absentEmp = emp;

        // Add `absentEmp` to the `absent` array if not already present
        if (!state.data.data.attendance[index].absent.includes(absentEmp)) {
          console.log('adding in absent');

          state.data.data.attendance[index].absent.push(absentEmp);

          // Use provided reason or carry forward from previous days
          let reasonToUse = reason;
          if (!reasonToUse) {
            reasonToUse = getCarriedForwardReason(state.data.data.attendance, index, absentEmp);
            console.log(
              `Carrying forward reason for employee ${absentEmp} on date ${date}: ${reasonToUse}`
            );
          } else {
            console.log(
              `Using provided reason for employee ${absentEmp} on date ${date}: ${reasonToUse}`
            );
          }

          state.data.data.attendance[index].absentReasons = {
            ...state.data.data.attendance[index].absentReasons,
            [String(absentEmp)]: reasonToUse,
          };

          // Auto-mark as absent for all future days with the same reason
          for (let i = index + 1; i < state.data.data.attendance.length; i++) {
            const futureAttendance = state.data.data.attendance[i];

            // Add to absent array if not already present
            if (!futureAttendance.absent.includes(absentEmp)) {
              futureAttendance.absent.push(absentEmp);
            }

            // Remove from present array if exists
            const futurePresentIndex = futureAttendance.present.indexOf(absentEmp);
            if (futurePresentIndex !== -1) {
              futureAttendance.present.splice(futurePresentIndex, 1);
            }

            // Set the reason for future days
            futureAttendance.absentReasons = {
              ...futureAttendance.absentReasons,
              [String(absentEmp)]: reasonToUse,
            };
          }
        }

        // Remove `absentEmp` from the `present` array if it exists
        const presentIndex = state.data.data.attendance[index].present.indexOf(absentEmp);
        if (presentIndex !== -1) {
          console.log('Removing from present');
          state.data.data.attendance[index].present.splice(presentIndex, 1);
        }
      }
    },
    selectAll(state, action) {
      const { date, present, reason } = action.payload;
      // Find the index of the object in the attendance array that matches the date
      const index = state.data.data.attendance.findIndex((obj) => obj.date === date);
      if (present) {
        // Extract just the IDs from batchTrainees array
        state.data.data.attendance[index].present = state.data.data.batchTrainees.map(
          (trainee) => trainee.id
        );
        state.data.data.attendance[index].absent = [];
        // Clear all absent reasons for this date
        state.data.data.attendance[index].absentReasons = {};

        // Clear absent status from all future days for all employees
        for (let i = index + 1; i < state.data.data.attendance.length; i++) {
          const futureAttendance = state.data.data.attendance[i];
          futureAttendance.absent = [];
          futureAttendance.absentReasons = {};
        }
      } else {
        // Extract just the IDs from batchTrainees array
        state.data.data.attendance[index].absent = state.data.data.batchTrainees.map(
          (trainee) => trainee.id
        );
        state.data.data.attendance[index].present = [];

        // Set reason for all employees if provided
        if (reason) {
          const absentReasons = {};
          state.data.data.batchTrainees.forEach((trainee) => {
            absentReasons[String(trainee.id)] = reason;
          });
          state.data.data.attendance[index].absentReasons = absentReasons;
        }

        // Auto-mark as absent for all future days with the same reason
        for (let i = index + 1; i < state.data.data.attendance.length; i++) {
          const futureAttendance = state.data.data.attendance[i];
          futureAttendance.absent = state.data.data.batchTrainees.map((trainee) => trainee.id);
          futureAttendance.present = [];

          // Set the reason for future days if provided
          if (reason) {
            const absentReasons = {};
            state.data.data.batchTrainees.forEach((trainee) => {
              absentReasons[String(trainee.id)] = reason;
            });
            futureAttendance.absentReasons = absentReasons;
          }
        }
      }
    },
    removeAll(state, action) {
      state.data.forEach((item) => (item.attendenceMarked = false));
      state.selectAllClicked = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendanceByBatchId.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = null;
      })
      .addCase(fetchAttendanceByBatchId.fulfilled, (state, action) => {
        // action.payload.map((elem) => {
        //   if (!elem["attendenceMarked"]) {
        //     elem["attendenceMarked"] = false;
        //   }
        // });
        state.data = action.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(fetchAttendanceByBatchId.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message || 'Failed to fetch data';
      });
  },
});

export const {
  setData,
  restForm,
  setError,
  setSuccess,
  markAttendence,
  selectAll,
  setbatchId,
  removeAll,
  addAttendence,
} = attendenceSlice.actions;

export default attendenceSlice.reducer;
